import React from 'react';

import {ChangeRequestComment} from 'src/openapi/models/ChangeRequestComment';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

type Props = {
    editedCommentId: number | null,
    currentComment: ChangeRequestComment,
    onEditComment: (comment: ChangeRequestComment) => void,
};

export const EditComment = ({editedCommentId, currentComment, onEditComment}: Props) => {
    const onEdit = () => {
        onEditComment(currentComment);
    };

    return (
        <>
            {editedCommentId === currentComment.id ?
                    <BasicIconButton iconProps={{type: Icons.PENCIL, size: Sizes.Size_16}}/> :
                    <BasicIconButton iconProps={{type: Icons.EDIT, size: Sizes.Size_16}} onClick={onEdit}/>}
        </>
    );
};
